import { useCallback } from "react"

import { OrderStatus } from "@/graphql/codegen/graphql"

const PRINTABLE_STATUSES = [OrderStatus.Sent, OrderStatus.Confirmed, OrderStatus.Completed] as const

type PrintableStatus = (typeof PRINTABLE_STATUSES)[number]

interface PrintActionReturn {
  canPrint: boolean
  handlePrint: () => void
}

export const usePrintAction = (status: OrderStatus | null | undefined): PrintActionReturn => {
  const canPrint = status ? PRINTABLE_STATUSES.includes(status as PrintableStatus) : false

  const handlePrint = useCallback(() => {
    // todo
  }, [])

  return {
    canPrint,
    handlePrint,
  } as const
}
